export const mockAssertPresenceValuesOnError =
  process.env.NEXT_PUBLIC_MOCK_ASSERT_PRESENCE_VALUES_ON_ERROR === 'true';

export const host = process.env.NEXT_PUBLIC_ONRAMP_BASE_URL as string;

export const apiHost = process.env.NEXT_PUBLIC_GRAPHQL_HOST as string;

export const isSandbox =
  process.env.NEXT_PUBLIC_SANDBOX_MODE === 'true' ||
  (typeof window !== 'undefined' && window.location.hostname.includes('pay-sandbox'));
